import Vuex from 'vuex';
import createPersistedState from "vuex-persist-indexeddb";

// list of modules
import auth from './modules/auth';
import users from './modules/users';
import companies from './modules/companies';
import storageLocations from './modules/storageLocations';
import assetTypeCategories from './modules/assetTypeCategories';
import uoms from './modules/uoms';
import assetTypes from './modules/assetTypes';
import assetTypeCodes from './modules/assetTypeCodes';
import assets from './modules/assets';
import connections from './modules/connections';
import transportations from './modules/transportations';
import dispatches from './modules/dispatches';
import inventorySessions from './modules/inventorySessions';
import stickerGenerator from './modules/stickerGenerator';
import notifications from './modules/notifications';
import assetPoolDistributions from './modules/assetPoolDistributions';
import assetIssuances from './modules/assetIssuances';
import inquiries from './modules/inquiries';
import repairs from './modules/repairs';
import disposals from './modules/disposals';

const createStore = () => {
	return new Vuex.Store({
		modules: {
			auth,
			users,
			companies,
			storageLocations,
			assetTypeCategories,
			uoms,
			assetTypes,
			assetTypeCodes,
			assets,
			connections,
			transportations,
			dispatches,
			inventorySessions,
			stickerGenerator,
			notifications,
			assetPoolDistributions,
			assetIssuances,
			inquiries,
			repairs,
			disposals,
		},
		state: {},
		mutations: {},
		actions: {
			resetLazyDataFlags({ commit }) {
				commit('SET_UOMS_LOADED', false);
				commit('SET_ASSET_TYPE_CATEGORIES_LOADED', false);
				commit('SET_TRANSPORTATIONS_LOADED', false);
				commit('SET_ASSET_TYPE_CODES_LOADED', false);
				commit('SET_USERS_LOADED', false);
				commit('SET_CONNECTED_USERS_LOADED', false);
				commit('SET_REGIONS_LOADED', false);
				commit('SET_AREAS_LOADED', false);
				commit('SET_COMPANIES_LOADED', false);
				commit('SET_CONNECTED_COMPANIES_LOADED', false);
				commit('SET_STORAGE_LOCATIONS_LOADED', false);
				commit('SET_CONNECTED_STORAGE_LOCATIONS_LOADED', false);
				commit('SET_CONNECTIONS_LOADED', false);
				commit('SET_ASSET_TYPES_LOADED', false);
			}
		},
		getters: {},
		plugins: [createPersistedState()]
	});
};

export default createStore;
